export const FROM_MOBILE_APP_STORAGE_KEY = "lcp_fromMobileApp";

export function readFromMobileAppFlag() {
  try {
    return sessionStorage.getItem(FROM_MOBILE_APP_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

/** True when opened inside the native app WebView (URL param or persisted session). */
export function isNativeAppWebView() {
  if (typeof window === "undefined") return false;
  if (typeof window.GameStatus?.postMessage === "function") return true;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("fromMobileApp") === "true") return true;
  } catch {
    /* ignore */
  }
  return readFromMobileAppFlag();
}

export function isCoarseTouchDevice() {
  if (typeof window === "undefined") return false;
  if (typeof navigator !== "undefined" && navigator.maxTouchPoints > 0) return true;
  return window.matchMedia?.("(pointer: coarse)")?.matches ?? false;
}

/** Prefer label-based file inputs (no programmatic .click()) on app WebView and touch devices. */
export function prefersNativeFilePickers() {
  return isNativeAppWebView() || isCoarseTouchDevice();
}
